import type { ReactNode } from "react";

import { AppCard, Typography } from "@/components/ui";
import { cn } from "@/lib/utils";

type TPageHeaderProps = {
  title: string;
  subtitle?: string | null;
  actions?: ReactNode;
  className?: string;
};

export function PageHeader({ title, subtitle, actions, className }: TPageHeaderProps) {
  return (
    <AppCard
      as="header"
      padding="lg"
      className={cn("shadow-sm", className)}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <Typography variant="h4" className="text-foreground">
            {title}
          </Typography>
          {subtitle ? (
            <Typography
              variant="p"
              affects="muted"
              className="mt-2 text-muted-foreground [&:not(:first-child)]:mt-2"
            >
              {subtitle}
            </Typography>
          ) : null}
        </div>
        {actions ? <div className="flex flex-shrink-0 items-center gap-2">{actions}</div> : null}
      </div>
    </AppCard>
  );
}
